import { render, staticRenderFns } from "./SocialCampaignTitle.vue?vue&type=template&id=72b05ade&scoped=true&"
import script from "./SocialCampaignTitle.vue?vue&type=script&lang=js&"
export * from "./SocialCampaignTitle.vue?vue&type=script&lang=js&"
import style0 from "./SocialCampaignTitle.vue?vue&type=style&index=0&id=72b05ade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b05ade",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72b05ade')) {
      api.createRecord('72b05ade', component.options)
    } else {
      api.reload('72b05ade', component.options)
    }
    module.hot.accept("./SocialCampaignTitle.vue?vue&type=template&id=72b05ade&scoped=true&", function () {
      api.rerender('72b05ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialCampaignTitle.vue"
export default component.exports